import ErrorBoundary from 'components/ErrorBoundary';
import GlobalLayout from 'components/GlobalLayout';
import GlobalMessage from 'components/GlobalMessage';
import GlobalModal from 'components/GlobalModal';
import { LiveChatAnchor } from 'components/LiveChat';
import { AlertProvider } from 'hooks/useAlert';
import StickyAlert from 'components/StickyAlert';
import useEdsExternalAssets from 'hooks/useEdsExternalAssets';

const App = ({ children }) => {
  // TODO: remove this hook once EDS header is ready for release & FF is removed - add stylesheet & script directly to `public/index.html` to be consistent with salesforce script injection
  useEdsExternalAssets();

  return (
    <ErrorBoundary>
      <AlertProvider>
        <GlobalMessage />
        <GlobalLayout>{children}</GlobalLayout>
        <LiveChatAnchor />
        <GlobalModal />
        <StickyAlert />
      </AlertProvider>
    </ErrorBoundary>
  );
};

export default App;
